import { Users, MapPin, Calendar } from "lucide-react";

function App() {
  return (
    <div className="h-screen w-screen bg-gradient-to-br from-gray-900 via-black to-gray-900 text-white flex flex-col overflow-hidden relative">
      {/* Decorative elements */}
      <div
        className="absolute top-10 left-10 w-96 h-96 bg-blue-500 rounded-full mix-blend-lighten filter blur-3xl opacity-20 animate-pulse"
        style={{ animationDuration: "8s" }}
      ></div>
      <div
        className="absolute bottom-10 right-10 w-96 h-96 bg-pink-500 rounded-full mix-blend-lighten filter blur-3xl opacity-20 animate-pulse"
        style={{ animationDelay: "4s", animationDuration: "10s" }}
      ></div>

      {/* Navigation */}
      <nav className="relative z-10 px-8 py-6 flex justify-between items-center">
        <div className="flex items-center space-x-3">
          <div className="w-8 h-8 bg-white rounded-lg flex items-center justify-center">
            <Users className="w-5 h-5 text-black" />
          </div>
          <span className="text-xl font-semibold tracking-tight">bonly</span>
        </div>
      </nav>

      {/* Main Content - Centered */}
      <div className="relative z-10 flex-1 flex items-center justify-center px-8">
        <div className="text-center w-full">
          <h1 className="font-bold mb-12 tracking-tight leading-none text-[18vw] lg:text-[200px]">
            bonly
          </h1>

          <div className="w-full px-4 md:max-w-2xl md:mx-auto">
            <p className="text-base md:text-lg text-white/60 mb-12 max-w-lg mx-auto leading-relaxed">
              Meet people in real life. Discover local events and connect with
              people nearby who share your interests.
            </p>

            {/* Feature Pills */}
            <div className="flex flex-wrap justify-center gap-4 mb-12">
              <div className="flex items-center space-x-2 px-5 py-3 bg-white/5 backdrop-blur-sm rounded-full border border-white/10">
                <MapPin className="w-4 h-4 text-blue-400" />
                <span className="text-sm font-medium text-white/70">
                  Find Local Events
                </span>
              </div>
              <div className="flex items-center space-x-2 px-5 py-3 bg-white/5 backdrop-blur-sm rounded-full border border-white/10">
                <Users className="w-4 h-4 text-purple-400" />
                <span className="text-sm font-medium text-white/70">
                  Meet New People
                </span>
              </div>
              <div className="flex items-center space-x-2 px-5 py-3 bg-white/5 backdrop-blur-sm rounded-full border border-white/10">
                <Calendar className="w-4 h-4 text-pink-400" />
                <span className="text-sm font-medium text-white/70">
                  Build Real Friendships
                </span>
              </div>
            </div>

            <p className="text-md text-white/60">Coming Soon</p>
          </div>
        </div>
      </div>

      {/* Footer */}
      <div className="relative z-10 px-8 py-6 flex justify-between items-center text-sm text-white/60">
        <p>© 2025 Bonly</p>
        <p>Bringing people together</p>
      </div>
    </div>
  );
}

export default App;
